import type { AppMeta, MetaEntity } from '@clientline/contracts';
import type { AdminPageAccessRule } from '../../registry.ts';

/**
 * Чи веде людина записи довідника: право створювати чи хоч одне поле, яке вона змінює (`/meta`
 * дає `edit` лише з правом `<e>.update` і областю зміни, platform meta.ts). Читати довідник можуть
 * і ті, хто його не веде, але їм він потрібен у формах (віджет E1b), а не в адмінці.
 */
export const maintains = (entity: MetaEntity): boolean =>
  entity.kind === 'reference' &&
  (entity.canCreate || entity.fields.some((f) => f.edit && !f.flags.includes('system')));

/** Хто бачить сторінку `references`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'data',
  permission: (meta: AppMeta) => meta.entities.some(maintains),
} satisfies AdminPageAccessRule;
